/** Row ⋮ menu — Focus item (ticker filter) with icon and active (blue) state. */

export const FOCUS_ICON_SVG = `<svg class="sfe-focus-menu-item-icon-svg" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="3.2" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.8"/><path d="M12 2.5v3.2M12 18.3v3.2M2.5 12h3.2M18.3 12h3.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`;

function escAttr(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

export function renderRowFilterMenuItem(options: {
  active: boolean;
  actionAttr: string;
  actionValue: string;
  attrs?: Record<string, string>;
}): string {
  const cls = `sfe-focus-menu-item sfe-focus-menu-item-filter${options.active ? " is-active" : ""}`;
  const extra = options.attrs
    ? Object.entries(options.attrs)
        .map(([key, value]) => ` ${escAttr(key)}="${escAttr(value)}"`)
        .join("")
    : "";
  const pressed = options.active ? ' aria-pressed="true"' : ' aria-pressed="false"';
  return `<button type="button" class="${cls}" role="menuitem" ${escAttr(options.actionAttr)}="${escAttr(options.actionValue)}"${extra}${pressed}>
    <span class="sfe-focus-menu-item-label">Focus</span>
    <span class="sfe-focus-menu-item-icon">${FOCUS_ICON_SVG}</span>
  </button>`;
}
